<!-- 登录组件 -->
<template>
  <div v-if="visible">
    <div class="container-mobile">
      <div class="title">{{ $t('mobile_login.title') }}</div>
      <div class="phone-box">
        <div @click.stop="nationalCode"
             class="prefix-wrap">
          <div class="prefix-text">{{ form.nationalCode ? '+' + form.nationalCode : '' }}</div>
        </div>
        <input v-model="form.phone"
               type="number"
               class="phone"
               :class="{ 'fix3': form.nationalCode.length == 3, 'fix4': form.nationalCode.length == 4 }"
               :placeholder="$t('mobile_login.phoneRequired')">
        </input>
      </div>

      <div :class="['text-error', { 'hide': !phoneErrMsg }]">{{ phoneErrMsg }}</div>
      <div class="code-box">
        <input v-model="form.verifyCode"
               type="number"
               class="code"
               :class="{ 'code-zh': isZh}"
               :placeholder="$t('mobile_login.verifyCodeRequired')">
        </input>
        <div @click.stop="sendCode"
             class="suffix-wrap"
             :class="{ 'suffix-text': !sendCodeDisable, 'suffix-disable': sendCodeDisable }">{{ sendCodeText }}</div>
      </div>

      <div :class="['text-error', { 'hide': !errMsg }]">{{ errMsg }}</div>
      <div class="login-btn">
        <button type="button"
                @click.stop="login">
          <span>{{ $t('mobile_login.btnName') }}</span>
        </button>
      </div>
      <div class="oauth-login">
        <img :src="weixinIcon"
             @click.stop="wxLogin" />
        <img :src="qqIcon"
             @click.stop="qqLogin" />
        <img :src="facebookIcon"
             @click.stop="fbLogin" />
      </div>
      <div class="text-license">
        <span>{{ $t('mobile_login.agreeLic') }}</span>
        <span>
          <a target="_blank"
             :href="goLinkUrl['terms'][goLinkeKey]">{{ $t('mobile_login.lic') }}</a>
        </span>
      </div>
    </div>
    <div class="mask"
         @click.stop="hideLogin"></div>
    <VueCountryIntl ref="vci"
                    modalClass="national-code-modal"
                    schema="modal"
                    :listZIndex="5000"
                    :visible.sync="codeModalStatus"
                    :iso2="iso2"
                    v-model="form.nationalCode"></VueCountryIntl>
  </div>
</template>

<script>
import Vue from 'vue'
import constans from 'Constans';
import cookie from 'Common/cookie';
import ajax from 'Common/ajax';
import { Dialog, Input, Button, Image } from "element-ui";
// import facebookIcon from '../images/fb.png';
// import qqIcon from '../images/qq.png';
// import weixinIcon from '../images/weixin.png';

import VueCountryIntl from 'vue-country-intl';
import 'vue-country-intl/lib/vue-country-intl.css'
import { countriesData } from 'vue-country-intl/src/components/vue-country-intl/data'


const userUrl = constans.AllUrl.url.dev
//应用id
const wx_appid = constans.AllUrl.appid.wx //微信appid
const qq_client_id = constans.AllUrl.appid.qq //QQ client_id
const facebook_client_id = constans.AllUrl.appid.facebook //facebook client_id
//回调地址
const wx_redirect_uri = constans.AllUrl.redirect_uri.wx_url //微信回调地址
const qq_redirect_uri = constans.AllUrl.redirect_uri.qq_url //QQ回调地址
const facebook_redirect_uri = constans.AllUrl.redirect_uri.facebook_url //facebook回调地址

// Vue.use(VueI18n)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Button)
Vue.use(VueCountryIntl)




export default {
  name: 'login',
  components: {
    elDialog: Dialog,
    elInput: Input,
    Button,
    elImage: Image,
    VueCountryIntl
  },
  props: {
  },
  data () {
    return {
      visible: false,
      phoneErrMsg: '',
      errMsg: '',
      isZh: false,
      form: {
        phone: '',
        code: '',
        nationalCode: '86', //手机区号
        verifyCode: ''
      },
      iso2: 'cn',
      codeModalStatus: false,
      sendCodeText: this.$t('mobile_login.sendCode'),
      sendCodeDisable: false,
      countDownTimer: null,
      facebookIcon:'https://static.lespark.cn/pc_img/images/fb.png',
      qqIcon:'https://static.lespark.cn/pc_img/images/qq.png',
      weixinIcon:'https://static.lespark.cn/pc_img/images/weixin.png',
      refId: '',
      registered: true,
      goLinkUrl: constans.UrlLink.goLink.mobileLogin,
      goLinkeKey: constans.UrlLink.getUrlKey(),
    }
  },
  created () {
    const lanMap = {
      'zh-cn': 'cn',
      'en-us': 'us',
      'zh-tw': 'tw',
      'zh-hk': 'hk',
      'zh-mo': 'mo',//澳门
      'th': 'th',//泰国
      'ms': 'my',//马来西亚
      'ms-my': 'my',//马来西亚
      'en-my': 'my',//马来西亚
      'en-sg': 'sg',//新加坡
      'zh-sg': 'sg',//新加坡
      'ja': 'jp',//日本
      'ko': 'kr',//韩国
      'ko-kr': 'kr',//韩国
      'en-au': 'au',//澳大利亚
      'en-gb': 'gb',//英国
      'en-gb-oxendict': 'gb',//英国
      'fil': 'ph',//菲律宾
      'vi': 'vn',//越南
    }
    const country = countriesData.find(item => {
      return item.iso2 == lanMap[(window.navigator.language || window.navigator.userLanguage).toLowerCase()]
    });
    if (country) {
      this.form.nationalCode = country.dialCode
      this.iso2 = country.iso2
    }

    const _lan = window.navigator.language.toLowerCase()
    if (_lan.startsWith('zh-')) {
      this.isZh = true
    } else {
      this.isZh = false
    }

    // this.showLogin()
  },
  mounted () {
  },
  methods: {
    //发送验证码
    sendCode () {
      if (this.sendCodeDisable) {
        return
      }
      if (this.validPhone()) {
        this.sendCodeDisable = true
        this.getVerifyCode()
      }
    },
    nationalCode () {
      this.codeModalStatus = true
    },
    countDown () {
      let delay = 60
      const text = this.sendCodeText
      this.sendCodeText = this.$t('mobile_login.resendCode') + `(${delay})`
      this.countDownTimer = setInterval(() => {
        if (delay <= 1) {
          this.resetSendCodeBtn()
        } else {
          this.sendCodeText = this.$t('mobile_login.resendCode') + `(${--delay})`
        }

      }, 1e3)
    },
    //调用发送验证码接口
    getVerifyCode () {
      try {
        ajax.Get({
          url: userUrl + '/v2/verify_code',
          params: {
            phone_number: `${this.form.nationalCode}${this.form.phone}`,
            source: 'h5_register',
            code_type: 0
          },
          /* mock: {
            "msg": "Verification code is  sent",
            "data": {
              "token": null,
              "user_id": "61a71fe74df379171dd02ae9",
              "reference_id": "ba076676-53fc-11ec-84cf-00163e03ab95"
            },
            "error": 0
          } */
        }).then(res => {
          this.errMsg = ''
          if (res.error == 0) {
            this.refId = res.data.reference_id
            cookie.setCookie('lespark_user_id', res.data.user_id)
            // cookie.setCookie('lespark_token', res.data.token)
            this.registered = res.data.user_id ? true : false
            this.countDown()
          } else {
            this.resetSendCodeBtn()
            let msg = this.$t('mobile_login.sendCodeFail')
            if (res.error == 8012) {
              msg = this.$t('error.unsafeEnv')
            }
            this.errMsg = msg
          }
        })
        return true
      } catch (e) {
        console.log(e)
        this.resetSendCodeBtn()
        this.errMsg = this.$t('mobile_login.sendCodeFail')
        return false
      }
    },
    userReg () {
      try {
        ajax.Post({
          url: userUrl + '/v3/register_invite',
          params: {
            phone: `${this.form.nationalCode}${this.form.phone}`,
            verify_code: this.form.verifyCode,
            bundle_id: 'co.cc.lespro',
            client_version: '7.6.0',
            reference_id: this.refId
          },
          /* mock: {
            "msg": "ok",
            "data": {
              "lgid": 8031996,
              "token": {
                "access_token": "6afa83a763455e7e247550dd5d2230f8",
                "refresh_token_expire_in": 86400,
                "token_type": "bearer",
                "access_token_expire_in": 7200,
                "scope": "user",
                "refresh_token": "9c8376bc1ff5b57a93e4e6bcf269a54f"
              },
              "user_id": "61a713eed8964f59f862a572",
              "avatar": "http://img2.lespark.cn/avatar/ali86defaultavatarchicken.png_150x150",
              "verify": 0,
              "nickname": "les75417964",
              "email": "883b1cc3@lespark.us",
              "shumei_token_id": "a212851c-526e-11ec-926c-00163e0a5fec_1638339566",
              "device_id": ""
            },
            "error": 0
          } */
        }).then(res => {
          if (res.error == 0) {
            // cookie.setCookie('lespark_token', res.data.token.access_token)
            cookie.setCookie('lespark_user_id', res.data.user_id)
          }
          this.$emit('completed', res)
        })
        return true
      } catch (e) {
        console.log(e)
        e.error = -1
        this.$emit('completed', e)
        return false
      }
    },
    validPhone () {
      this.phoneErrMsg = ''
      if (!this.form.phone || isNaN(this.form.phone)) {
        this.phoneErrMsg = this.$t('mobile_login.errPhoneFormat')
        return false
      }
      return true
    },
    validCode () {
      this.errMsg = ''
      if (this.form.verifyCode) {
        if (!/^[a-z0-9A-Z]+$/.test(this.form.verifyCode)) {
          this.errMsg = this.$t('mobile_login.errVerifyCodeFormat')
          return false
        }
        return true
      } else {
        this.errMsg = this.$t('mobile_login.errVerifyCodeRequired')
        return false
      }
    },
    resetSendCodeBtn () {
      if (this.countDownTimer) {
        clearInterval(this.countDownTimer)
      }
      this.sendCodeDisable = false
      this.sendCodeText = this.$t('mobile_login.sendCode')
    },
    // 切换登录
    wxLogin () {
      let state = window.location.href
      self.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + wx_appid + '&redirect_uri=' + wx_redirect_uri + '&response_type=code&scope=snsapi_login&state=' + state + '#wechat_redirect'
    },
    qqLogin () {
      let state = window.location.href
      self.location.href = 'https://graph.qq.com/oauth2.0/authorize?client_id=' + qq_client_id + '&redirect_uri=' + qq_redirect_uri + '&response_type=code&state=' + state
    },
    fbLogin () {
      let state = window.location.href
      const SCOPE = "&scope=email"
      self.location.href = 'https://www.facebook.com/dialog/oauth?client_id=' + facebook_client_id + '&redirect_uri=' + facebook_redirect_uri + '&response_type=code' + SCOPE + '&state=' + state
    },
    showLogin () {
      this.visible = true
    },
    hideLogin () {
      this.visible = false
    },
    // 登录按钮(手机号码登录)
    login () {
      if (!this.validPhone() || !this.validCode()) {
        return false
      }
      if (!this.registered) {
        this.userReg()
        return
      }
      try {
        ajax.Post({
          url: userUrl + '/v2/verify_code',
          params: {
            verify_code: this.form.verifyCode,
            reference_id: this.refId,
            phone_number: this.form.nationalCode+this.form.phone,
            area_code: this.form.nationalCode,
            user_id: cookie.getCookie("lespark_user_id") || ""
          },
        }).then(res => {
          if (res.error == 0) {
            cookie.setCookie('lespark_token', res.data.token)
            cookie.setCookie('lespark_user_id', res.data.user_id)
          }
          this.$emit('completed', res)
        }).catch(e => {
          this.$emit('completed', e)
        })
      } catch (e) {
        e.error = -1
        this.$emit('completed', e)
      }
    }
  }
}
</script>
<style type="text/css">
.national-code-modal .country-modal-search-box {
  width: auto;
}
</style>

<style lang="scss" scoped>
.container-mobile {
  border-radius: 3.2vw;
  background: #ffffff;
  position: absolute;
  top: 35.73333vw;
  left: 8vw;
  right: 8vw;
  z-index: 4;
  padding: 8vw 6.66667vw 0 6.66667vw;
  .title {
    height: 5.86667vw;
    font-size: 4.8vw;
    font-weight: 600;
    color: #333333;
    text-align: center;
  }

  .phone-box,
  .code-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 1.0667vw;
    border: 0.2667vw solid #dcdfe6;
    padding: 0 2vw;
  }

  .phone-box {
    margin-top: 8vw;
    .prefix-wrap {
      position: relative;
      height: 6.4vw !important;
      padding: 0.4vw 1.8vw !important;
      border-right: 0.2667vw solid #ebebeb !important;
    }

    .prefix-wrap .prefix-text {
      font-size: 4vw !important;
      color: #333333 !important;
    }
  }
  .code-box {
    margin-top: 5.33333vw;
    .code {
      padding: 0;
    }
    .suffix-wrap {
      font-size: 4vw;
    }
    .suffix-text {
      color: #4498fb;
    }
    .suffix-disable {
      color: #a8a8a8;
    }
  }
}
.phone,
.code {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  -webkit-box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 10.6vw;
  line-height: 10.6vw;
  outline: 0;
  padding: 0 2vw;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 4vw;
  width: 100%;
  border: none;
}
.login-btn {
  margin-top: 8vw;
  text-align: center;
  button {
    height: 11.73333vw;
    background: #fa3e54;
    border-radius: 5.86667vw;
    padding: 0;
    border: none;
    width: 100%;
    span {
      height: 5.6vw;
      font-size: 4vw;
      color: #ffffff;
    }
  }
}
.oauth-login {
  margin-top: 8vw;
  display: flex;
  justify-content: space-evenly;
  img {
    width: 13.33333vw;
    height: 13.33333vw;
  }
}
.text-license {
  margin: 8.26667vw 0 5.33333vw;
  text-align: center;
  span:first-child {
    font-size: 3.46667vw;
    color: #a8a8a8;
  }
  span:last-child {
    font-size: 3.46667vw;
    color: #4498fb;
  }
  a:visited {
    color: #4498fb;
  }
}
.mask {
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
}

.hide {
  display: none;
}
.text-error {
  color: red;
  text-align: center;
}
.national-code-modal .country-modal-search-box {
  width: auto !important;
}

.code-zh {
  width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/views/components/mobileLogin.vue